<mat-toolbar>
  <div class="dialog-confirm-header">
    <h3 class="dialog-confirm-title">{{ title }}</h3>
    <button mat-button type="button" (click)="onCloseClick($event)">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</mat-toolbar>

<div class="content">
  <div *ngIf="options" class="divCheckboxs">
    <h1>Desmarque o item que ainda NÃO foi checkado:</h1>

    <div class="checkboxes">
      <div
        *ngFor="let medication of options; let i = index"
        class="divCheckbox"
      >
        <input
          class="checkboxMedication"
          type="checkbox"
          [id]="medication.name + '-' + i"
          [value]="medication.name"
          checked
        />
        <label class="labelCheckbox" [for]="medication.name + '-' + i">
          {{ medication.name }} - {{ medication.time }}
        </label>
      </div>
    </div>
  </div>

  <div *ngIf="data.input" class="dialog-confirm-content">
    <div class="input-text">
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>{{ label }}</mat-label>
        <input
          matInput
          #inputDialogConfirm
          [formControl]="inputControl"
          [type]="type"
          [placeholder]="placeholder"
          [title]="inputTitle"
          required
        />

        <mat-error *ngIf="inputControl.hasError('required')">
          Campo obrigatório
        </mat-error>
        <mat-error *ngIf="inputControl.hasError('pattern')">
          Formato inválido. {{ inputTitle }}
        </mat-error>
      </mat-form-field>
    </div>
  </div>
</div>

<div *ngIf="text" class="dialog-confirm-content">
  <p>{{ text }}</p>
</div>

<mat-toolbar>
  <div class="dialog-confirm-bottom">
    <button mat-button type="button" (click)="onCancelClick($event)">
      <mat-icon>cancel</mat-icon>
      <span>Cancelar</span>
    </button>

    <button mat-button type="submit" (click)="onConfirmClick($event)">
      <mat-icon>check</mat-icon>
      <span>Confirmar</span>
    </button>
  </div>
</mat-toolbar>
